import { render } from "./newsActive.vue?vue&type=template&id=4447d976&scoped=true"
import script from "./newsActive.vue?vue&type=script&lang=js"
export * from "./newsActive.vue?vue&type=script&lang=js"

import "./newsActive.vue?vue&type=style&index=0&id=4447d976&scoped=true&lang=css"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4447d976"]])

export default __exports__